export {default} from './WalletsSettings';
